<div class="header-class col-sm-12 title">
    <h6>Lignes du bon à payer : {{ bpLineFormArray?bpLineFormArray.controls.length: ''}}</h6>
    <button type="button" mat-raised-button color="success" (click)="addBpRow()">
        <mat-icon>add_box</mat-icon>
        Ajouter une ligne BP
    </button>
</div>

<div *ngIf="form" id="incremented-line-list" class="col-sm-12">
    <form [formGroup]="form">
        <div class="table-container col-sm-12">
            <table #table mat-table [dataSource]="matDataSourceBpLigne" formArrayName="bpLines">
                <caption>Liste des Bps lignes</caption>
                <ng-container matColumnDef="annule">
                    <th mat-header-cell *matHeaderCellDef> A </th>
                    <td mat-cell *matCellDef="let row;let index = index" [formGroupName]="index" class="align-cell">
                        <mat-checkbox *ngIf="!row.get('bAnnule').value"
                                    (change)="changeAnnule(row)"
                                    [checked]="selection.isSelected(row)"
                                    [aria-label]="checkboxLabel(row)">
                        </mat-checkbox>
                        <mat-icon class="align-icon" *ngIf="row.get('bAnnule').value"
                        style="color: rgb(189, 13, 13);">cancel</mat-icon>
                    </td>
                </ng-container>

                <ng-container matColumnDef="code">
                    <th mat-header-cell *matHeaderCellDef> N° BC </th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index">
                        <div *ngIf="element.get('bcLigne').value">
                            {{element.get('bcLigne').value.bc.code}}
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="position">
                    <th mat-header-cell *matHeaderCellDef> N° Ligne </th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index">
                        {{element.get('position').value}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="libelle">
                    <th mat-header-cell *matHeaderCellDef> Désignation </th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                    [ngClass]="{'orangeBack': element.get('bcLigne').value ? (element.get('libelle').value != element.get('bcLigne').value.libelle) : true}">
                        {{element.get('libelle').value}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="qteBC">
                    <th mat-header-cell *matHeaderCellDef> Qte BC </th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index" class="allign-right">
                        <div *ngIf="element.get('bcLigne').value">
                            {{element.get('bcLigne').value.qte | number:'1.3-3' :'fr'}}
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="qteRestant">
                    <th mat-header-cell *matHeaderCellDef> Qte Restante </th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                        class="allign-right"
                        [ngClass]="{'orangeBack': element.get('bcLigne').value && element.get('qte').value ? (element.get('qte').value != element.get('bcLigne').value.qteRestant) : true}"
                        >
                        <div *ngIf="element.get('bcLigne').value">
                            {{element.get('bcLigne').value.qteRestant | number:'1.3-3' :'fr'}}
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="qteLivre">
                    <th mat-header-cell *matHeaderCellDef> Qte Livre </th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                        class="allign-right">
                        <div *ngIf="element.get('bcLigne').value">
                            {{element.get('bcLigne').value.qteLivre | number:'1.3-3' :'fr'}}
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="qteBP">
                    <th mat-header-cell *matHeaderCellDef> Qte BP </th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index" 
                    [ngClass]="{'orangeBack': element.get('bcLigne').value ? (element.get('qte').value > element.get('bcLigne').value.qteRestant) : true}">
                        {{ element.get('qte').value| number:'1.4-4' :'fr'}}
                    </td>
                </ng-container>
        
                <ng-container matColumnDef="puBC">
                    <th mat-header-cell *matHeaderCellDef> PU BC</th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                        class="allign-right">
                        <div *ngIf="element.get('bcLigne').value">
                            {{element.get('bcLigne').value.pu | currency:'EUR':'symbol':'1.2-2':'fr'}}           
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="puBP">
                    <th mat-header-cell *matHeaderCellDef> PU BP </th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index" 
                        class="allign-right"
                        [ngClass]="{'orangeBack': element.get('bcLigne').value ? (element.get('pu').value != element.get('bcLigne').value.pu) : true}">
                        {{element.get('pu').value | currency:'EUR':'symbol':'1.2-2':'fr'}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="htBC">
                    <th mat-header-cell *matHeaderCellDef> HT BC</th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                        class="allign-right">
                        <div *ngIf="element.get('bcLigne').value">
                            {{element.get('bcLigne').value.ht | currency:'EUR':'symbol':'1.2-2':'fr'}}
                        </div>
                    </td>
                </ng-container>
                
                <ng-container matColumnDef="htRestant">
                    <th mat-header-cell *matHeaderCellDef> HT Restant</th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                        class="allign-right">
                        <div *ngIf="element.get('bcLigne').value">
                            {{element.get('bcLigne').value.htRestant| currency:'EUR':'symbol':'1.2-2':'fr'}}
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="htBP">
                    <th mat-header-cell *matHeaderCellDef> HT BP</th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                        class="allign-right"
                        [ngClass]="{'orangeBack': element.get('bcLigne').value ? (element.get('ht').value > element.get('bcLigne').value.htRestant) : true}">
                        {{element.get('ht').value| currency:'EUR':'symbol':'1.2-2':'fr'}}
                    </td>
                </ng-container>
                
                <ng-container matColumnDef="tva">
                    <th mat-header-cell *matHeaderCellDef> TVA </th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                    [ngClass]="{'orangeBack': element.get('bcLigne').value ? (element.get('codeTva').value != element.get('bcLigne').value.codeTva) : true}">
                        <div> {{element.get('codeTva').value}} - {{element.get('libelleTva').value }}</div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="naCode">
                    <th mat-header-cell *matHeaderCellDef> NA </th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                        [matTooltip]="element.get('libelleNa').value"
                        [ngClass]="{'orangeBack': element.get('bcLigne').value ? (element.get('codeNa').value != element.get('bcLigne').value.codeNa) : true}">
                        <div> {{element.get('codeNa').value}} </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="cg">
                    <th mat-header-cell *matHeaderCellDef> CG Charge </th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                        [matTooltip]="element.get('libelleCgCharge').value"
                        [ngClass]="{'orangeBack': element.get('bcLigne').value ? (element.get('codeCgCharge').value != element.get('bcLigne').value.codeCgCharge) : true}">
                        <div> {{element.get('codeCgCharge').value}} </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="ca1">
                    <th mat-header-cell *matHeaderCellDef> CA1 </th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                        [matTooltip]="element.get('libelleCa1').value"
                        [ngClass]="{'orangeBack': element.get('bcLigne').value ? (element.get('codeCa1').value != element.get('bcLigne').value.codeCa1) : true}">
                        <div>{{element.get('codeCa1').value}} </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="ca2">
                    <th mat-header-cell *matHeaderCellDef> CA2 </th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                        [matTooltip]="element.get('libelleCa2').value"
                        [ngClass]="{'orangeBack': element.get('bcLigne').value ? (element.get('codeCa2').value != element.get('bcLigne').value.codeCa2) : true}">
                        <div>{{element.get('codeCa2').value}} </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="complement">
                    <th mat-header-cell *matHeaderCellDef> Complément </th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                        [matTooltip]="element.get('libelleComp').value"
                        [ngClass]="{'orangeBack': element.get('bcLigne').value ? (element.get('codeComp').value != element.get('bcLigne').value.codeComp) : true}">
                        <div>{{element.get('codeComp').value}}</div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="equipement">
                    <th mat-header-cell *matHeaderCellDef> Equipement</th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                    [ngClass]="{'orangeBack': element.get('bcLigne').value ? (element.get('vehicule').value != element.get('bcLigne').value.vehicule) : true}">
                        <div>{{element.get('vehicule').value}} </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="codeAe">
                    <th mat-header-cell *matHeaderCellDef>Code Chantier</th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                    [ngClass]="{'orangeBack': element.get('bcLigne').value ? (element.get('chantier').value != element.get('bcLigne').value.chantier) : true}">
                        <div>{{element.get('chantier').value}} </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="ttc">
                    <th mat-header-cell *matHeaderCellDef> TTC</th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                        class="allign-right"
                        [ngClass]="{'orangeBack': element.get('bcLigne').value ? (element.get('ttc').value != element.get('bcLigne').value.ttc) : true}">
                        <div>{{element.get('ttc').value | currency:'EUR':'symbol':'1.2-2':'fr'}} </div>
                    </td>
                </ng-container> 


                <tr mat-header-row *matHeaderRowDef="displayedColumnsBp ;sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsBp; let i = index" (click)="openModal(i, row)"></tr>
                
            </table>
        </div>
    </form>
</div>